import React from 'react';
import { Paper } from '@mui/material';
import ShimmerBox from './ShimmerBox';

export interface TableShimmerProps {
  columns?: number;
  rows?: number;
  showSelection?: boolean;
  minHeight?: number | string;
  className?: string;
}

const TableShimmer: React.FC<TableShimmerProps> = ({
  columns = 4,
  rows = 8,
  showSelection = false,
  minHeight = 320,
  className = '',
}) => {
  const columnKeys = Array.from({ length: columns }, (_, index) => `col-${index}`);
  const rowKeys = Array.from({ length: rows }, (_, index) => `row-${index}`);

  return (
    <Paper
      elevation={0}
      data-testid="table-shimmer"
      className={['wday-table-shimmer overflow-hidden rounded-lg', className]
        .filter(Boolean)
        .join(' ')}
      sx={{
        border: 'none',
        boxShadow: '0 1px 2px rgba(0,0,0,0.06), 0 6px 20px rgba(0,0,0,0.08)',
        minHeight,
        width: '100%',
      }}
    >
      <div
        className="flex items-center gap-3 px-4 py-3"
        style={{
          backgroundColor: 'var(--table-header-bg, #f8f9ff)',
          borderBottom: '1px solid var(--border-light, #f1f5f9)',
        }}
      >
        {showSelection && <ShimmerBox className="h-4 w-4 shrink-0 rounded-full" />}
        {columnKeys.map((key, index) => (
          <ShimmerBox
            key={key}
            className="h-3 rounded"
            style={{ width: index === 0 ? '28%' : `${Math.max(12, 60 / columns)}%` }}
          />
        ))}
      </div>

      <div className="flex flex-col">
        {rowKeys.map((key) => (
          <div
            key={key}
            className="flex items-center gap-3 px-4 py-3.5"
            style={{ borderBottom: '1px solid var(--border-light, #f1f5f9)' }}
          >
            {showSelection && <ShimmerBox className="h-4 w-4 shrink-0 rounded-full" />}
            {columnKeys.map((colKey, index) => (
              <ShimmerBox
                key={`${key}-${colKey}`}
                className="h-3.5 rounded-md"
                style={{
                  width:
                    index === 0
                      ? '32%'
                      : index === columns - 1
                        ? '18%'
                        : `${Math.max(14, 52 / columns)}%`,
                }}
              />
            ))}
          </div>
        ))}
      </div>
    </Paper>
  );
};

export default TableShimmer;
